import Vue from 'vue'
import Router from 'vue-router'
import index from "../views/index";
import hardware from "../views/hardware"
import service from "../views/service"
import software from "../views/software"
import contact from "../views/contact"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/hardware',
      name: 'hardware',
      component: hardware
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/software',
      name: 'software',
      component: software
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js